import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";

import enTranslations from './components/Middlewares/locales/enTranslation';
import esTranslations from './components/Middlewares/locales/esTranslation';

// the translations
const resources = {
    EN: {
        translation: { ...enTranslations }
    },
    ES: {
        translation: { ...esTranslations }
    }
};

i18n
    .use(reactI18nextModule) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "EN",

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;